// src/components/common/SaveButtonBar.js

import { Typography, Box, Button } from "@mui/material";
import { Save as IconSave } from "@mui/icons-material";

const SaveButtonBar = ({
    text = "Guardar",
    onClick,
    disabled = false,
    icon = <IconSave />
}) => {
    return (
        <Typography gutterBottom component="span">
            <Box textAlign="center" padding={1}>
                <Button
                    variant="outlined"
                    size="small"
                    onClick={onClick}
                    disabled={disabled}
                >
                    {text}
                    {icon}
                </Button>
            </Box>
        </Typography>
    );
};

export default SaveButtonBar;
